import React from "react";
import SectionTitle from './section-title'
import "./book-page.m.css";

const houseImages = [
  "h8si59v5/abandoners-.png",
  "bhfif2nb/skippers-.png",
  "g7gbpbc1/hoaders-.png",
  "xg8gx5ja/spinecrackers.png",
];

export default function HouseBlocks() {
  return (
    <section styleName="house-blocks">
      <SectionTitle
        title="We Welcome All The Reading Criminals:"
        width="30%"
      />

      <div styleName="house-grid">
        {houseImages.map((img, index) => (
          <div key={index} styleName="house-card">
            <img
              loading="lazy"
              src={`https://images.assettype.com/newslaundry/2026-07-14/${img}`}
              alt=""
              styleName="house-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
}